import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface LoginCardProps {
  children: ReactNode;
  isShaking: boolean;
}

export function LoginCard({ children, isShaking }: LoginCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{
        opacity: 1,
        y: 0,
        x: isShaking ? [0, -10, 10, -10, 10, 0] : 0,
      }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
